module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst disabled = fieldConfig.disabled\nconst isActive = !fieldConfig.isOptional || fieldConfig.isActivated\nconst separatedFieldCodes = fieldConfig.separatedFieldCodes || {}\nconst additionalClasses = []\nif(disabled) additionalClasses.push('disabled')\nconst additionalAttributes = []\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n%>\n<div <%- additionalAttributes.join(' ')%> data-field-type=\"time-range-picker\" data-field-code=\"<%= model.fieldCode %>\">\n<%\nif(fieldConfig.isOptional){\n%><%- include('./toggle', { model: { fieldCode: 'activated', dataINT: isActive ? 1 : 0, atom: { dataType: 'boolean' }, config: { disabled, strict: true, slimSwitch: true }}}) %><%\n}\n%>\n<%- include('./time-picker', { model: { config: { ...(fieldConfig.time || {}), defaultDataTIME: fieldConfig.defaultFromTIME, disabled: disabled || !isActive }, fieldCode: 'fromTIME', dataTIME: model.dataJSON[separatedFieldCodes.fromTIME] || '' }}); %>\n<div>-</div>\n<%- include('./time-picker', { model: { config: { ...(fieldConfig.time || {}), defaultDataTIME: fieldConfig.defaultToTIME, disabled: disabled || !isActive }, fieldCode: 'toTIME', dataTIME: model.dataJSON[separatedFieldCodes.toTIME] || '' }}); %>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\time-range-picker.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const disabled = fieldConfig.disabled
const isActive = !fieldConfig.isOptional || fieldConfig.isActivated
const separatedFieldCodes = fieldConfig.separatedFieldCodes || {}
const additionalClasses = []
if(disabled) additionalClasses.push('disabled')
const additionalAttributes = []
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)

    ; __line = 10
    ; __append("\n<div ")
    ; __line = 11
    ; __append( additionalAttributes.join(' '))
    ; __append(" data-field-type=\"time-range-picker\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\">\n")
    ; __line = 12
    ; 
if(fieldConfig.isOptional){

    ; __line = 14
    ; __append( include('./toggle', { model: { fieldCode: 'activated', dataINT: isActive ? 1 : 0, atom: { dataType: 'boolean' }, config: { disabled, strict: true, slimSwitch: true }}}) )
    ; 
}

    ; __line = 16
    ; __append("\n")
    ; __line = 17
    ; __append( include('./time-picker', { model: { config: { ...(fieldConfig.time || {}), defaultDataTIME: fieldConfig.defaultFromTIME, disabled: disabled || !isActive }, fieldCode: 'fromTIME', dataTIME: model.dataJSON[separatedFieldCodes.fromTIME] || '' }}) )
    ; __append("\n<div>-</div>\n")
    ; __line = 19
    ; __append( include('./time-picker', { model: { config: { ...(fieldConfig.time || {}), defaultDataTIME: fieldConfig.defaultToTIME, disabled: disabled || !isActive }, fieldCode: 'toTIME', dataTIME: model.dataJSON[separatedFieldCodes.toTIME] || '' }}) )
    ; __append("\n</div>")
    ; __line = 20
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\time-range-picker.ejs

}